// extracted by mini-css-extract-plugin
module.exports = {"root":"CardRow_root__7nIMs","column":"CardRow_column__SX3TT","firstRow":"CardRow_firstRow__lQUVm"};